import React, { useState, useEffect } from "react";
import {
  Ballot,
  Header,
  Footer,
  LineSplit,
  SignMeUp,
  AnswerQuestions,
  MoreInfo,
  AlertSignup,
  AlertDismissible,
  VoterGuide,
  Calendar,
} from "../components";
//import MediaQuery from 'react-responsive';
import config from "../lib/config";
import { Helmet } from "react-helmet-async";
import "./views.styles.scss";
import { useTranslation } from "react-i18next";
import client from "../sanityClient";

function HomePage() {
  let imageUrl = [
    window.location.protocol,
    "//",
    window.location.host,
    config.seo.home.image,
  ].join("");
  let ogUrl = window.location.origin;
  const [races, setRaces] = useState([]);
  const [selectedHomeRace, setSelectedHomeRace] = useState("");
  const { t, i18n } = useTranslation();

  const extractDistrictNumber = (name) => {
    const match = name.match(/(\d+)\s*$/);
    return match ? parseInt(match[1], 10) : 0;
  };

  const usHouseRaces = races
    .filter((race) => race.race_type === "U.S. House")
    .sort((a, b) => extractDistrictNumber(a.race_name) - extractDistrictNumber(b.race_name));
  const nonUsHouseRaces = races.filter((race) => race.race_type !== "U.S. House");

  const homeRaceOptions = usHouseRaces.map((race) => race.race_name);

  const filteredRaces = selectedHomeRace
    ? usHouseRaces.filter((race) => race.race_name === selectedHomeRace)
    : usHouseRaces;
  useEffect(() => {
    const fetchRaces = async () => {
      try {
        const query = `
      *[_type == 'racePage'
      ]
      | {
        _id,
        race_name,
        race_name_display,
        race_type,
        is_statewide,
        slug,
        "candidates": candidates[]-> | order(name asc),
        "order": select(
          race_type == "U.S. Senate" => 1,
          race_type == "U.S. House" => 2,
          race_type == "Governor" => 3,
          race_type == "Lieutenant Governor" => 4,
          race_type == "Secretary of State" => 5,
          race_type == "Commissioner of Insurance" => 6,
          race_type == "Commissioner of Labor" => 7,
          race_type == "School Superintendent" => 8,
          race_type == "Public Service Commissioner" => 9,
          race_type == "State Senate" => 10,
          race_type == "State House" => 11,
          race_type == "Mayor" => 12,
          race_type == "City Council" => 13,
          race_type == "City Commissioner" => 14,
          race_type == "Alderman" => 15,
          race_type == "Town Council" => 16,
          race_type == "School Board Chair" => 17,
          race_type == "School Board Member" => 18,
          race_type == "Georgia Supreme Court Justice" => 19,
        )
      }
      | order(order asc, _createdAt desc, school_board_district desc, county_district desc)
    `;
        const data = await client.fetch(query);
        setRaces(data);
      } catch (error) {
        console.error("Error fetching races for homepage:", error);
      }
    };
    fetchRaces();
  }, []);
  return (
    <div>
      <Helmet>
        <title>{t("seo_default_home_title")}</title>
        <meta
          name="description"
          content={t("seo_default_home_page_description")}
        />
        <meta name="image" content={imageUrl} />
        <meta name="twitter:title" content={t("seo_home_tw_title")} />
        <meta
          name="twitter:description"
          content={t("seo_home_tw_description")}
        />
        <meta name="twitter:image" content={imageUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta itemProp="name" content={t("seo_default_home_title")} />
        <meta
          itemProp="description"
          content={t("seo_default_home_page_description")}
        />
        <meta itemProp="image" content={imageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={ogUrl} />
        <meta property="og:title" content={t("seo_default_home_page_title")} />
        <meta
          property="og:description"
          content={t("seo_default_home_page_description")}
        />
        <meta property="og:image" content={imageUrl} />
      </Helmet>
      <div className="home-top-email">
        <AlertSignup />
      </div>
      <Header />

      <div id="page-wrap">
        <LineSplit />
        <VoterGuide isHome={true} />
        <LineSplit />
        <div className="home-psc-title">
          <h2>{t("home_primary_runoff_title")}</h2>
          <p>
            {t("home_primary_runoff_body")}
          </p>
        </div>
        <Ballot ballots={nonUsHouseRaces} />
        <LineSplit />
        <div className="home-psc-title">
          <h4>{t("home_primary_runoff_cd") || "Runoff Races"}</h4>
          <div className="home-race-selector">
            <select
              id="home-race-filter"
              value={selectedHomeRace}
              onChange={(e) => setSelectedHomeRace(e.target.value)}
              className="home-race-dropdown"
            >
              <option value="">All Races</option>
              {homeRaceOptions.map((name) => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <Ballot ballots={filteredRaces} />
        <LineSplit />
        <AnswerQuestions />
        <LineSplit />
        <Calendar isHome={true} />
        <LineSplit />
        <SignMeUp />
        <LineSplit />
        <Footer flat={true} />
      </div>
    </div>
  );
}

export default HomePage;
